<template>
  <div class="part-item projectBuilding">
    <p class="part-title">实验教学课程持续建设服务计划
    </p>
    <div class="part-content">
      <span class="content-title">课程持续建设</span>
      <div
        v-if="!formInfo.service_plan.buildArry"
        class="content-text"
      >：暂无内容</div>
      <div class="clearfix"></div>
      <div
        class="content-text-table"
        v-if="formInfo.service_plan.buildArry"
      >
        <table class="part-new-table">
          <tbody>
            <tr>
              <th
                class="th1"
                width="90"
              >日期</th>
              <th class="th2">描述</th>
            </tr>
            <tr
              class="continue-build-data"
              v-for="(item,index) in formInfo.service_plan.buildArry"
              :key="index"
            >
              <td>{{item.yaer}}</td>
              <td>{{item.describe}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">其他描述：</span>
      <div
        class="content-text"
        v-if="formInfo.service_plan.buildDescribe"
        v-html="formInfo.service_plan.buildDescribe"
      ></div>
      <div
        v-else
        class="content-text"
      >暂无内容</div>
      <div class="clearfix"></div>
      <span class="content-title">面向高校、社会的教学推广应用计划</span>
      <div
        v-if="!formInfo.service_plan.planArry"
        class="content-text"
      >：暂无内容</div>
      <div class="clearfix"></div>
      <div
        class="content-text-table"
        v-if="formInfo.service_plan.planArry"
      >
        <table class="part-new-table">
          <tbody>
            <tr>
              <th width="90">日期</th>
              <th>推广高校数</th>
              <th>应用人数</th>
              <th>推广行业数</th>
              <th>应用人数</th>
            </tr>
            <tr
              class="share-plan-data"
              v-for="(item,index) in formInfo.service_plan.planArry"
              :key="index"
            >
              <td>{{item.yaer}}</td>
              <td>{{item.university}}</td>
              <td>{{item.universityCound}}</td>
              <td>{{item.extend}}</td>
              <td>{{item.extendCount}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">其他描述：</span>
      <div
        class="content-text"
        v-if="formInfo.service_plan.planDescribe"
        v-html="formInfo.service_plan.planDescribe"
      ></div>
      <div
        v-else
        class="content-text"
      >暂无内容</div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ServicePlan',
  props: ['expId'],
  components: {
  },
  data () {
    return {
      formInfo: {
        service_plan: ''
      }
    }
  },
  methods: {
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.service_plan = data.service_plan ? JSON.parse(data.service_plan) : ''
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.part-content {
  .part-new-table {
    margin: 10px 0;
    border: 1px solid #ebebeb;
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    background-color: transparent;
    tr th {
      background-color: #f8faff;
      color: #999;
      font-weight: normal;
    }
  }
  .part-new-table tr th,
  .part-new-table tr td {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: middle;
    border: 1px solid #ebebeb;
    text-align: center;
  }
}
</style>
